import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import style from "./index.module.scss";
import { useTranslation } from "react-i18next";
import shopApi from "api/shop";
import { roles } from "constants/index";
import { formatPercent, getUser } from "utils/index";
import { Card, Space, Table } from "antd";
import moment from "moment";
import revenueApi from "api/revenue";
import userApi from "api/user";
import { rolesGetAllShop } from "features/inventory/roles";

const cx = classNames.bind(style);

const Netto = () => {
  const { t } = useTranslation();
  const [listShopDepartment, setListShopDepartment] = useState([]);
  const [netto, setNetto] = useState([]);
  const [loading, setLoading] = useState(false);

  const getInfoManager = async () => {
    try {
      setLoading(true);
      if (rolesGetAllShop.includes(+getUser().role)) {
        const res = await userApi.getUsers();
        setListShopDepartment(
          res.users.filter(user => user.role === roles.departmentManager).map((user) => ({
            managerName: user.name,
            shops: user.shops.map((shop) => shop.shop._id),
          }))
        );
      } else {
        const res = await shopApi.getShopByRole();
        setListShopDepartment([{
          managerName: getUser().name,
          shops: res.shops.map((shop) => shop.shop._id),
        }]);
      }
    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  const getNetto = async () => {
    try {
      setLoading(true);
      const listNetto = await Promise.all(listShopDepartment.map(shopDepartment => revenueApi.getGrowth({
        shops: shopDepartment.shops,
      })));

      setNetto(listNetto.map(item => item.list));
    } catch (error) {
      // Handle error
    }
    finally {
      setLoading(false);
    }
  }

  const columns = [
    {
      title: t('shopCode'),
      dataIndex: "shop_code",
      key: "shop_code",
    },
  ];
  // loop to add column for each month
  for (let i = 1; i <= 12; i++) {
    columns.push({
      title: moment(`${i}`, "MM").format("YYYY-MM"),
      dataIndex: `month_${i}`,
      key: `month_${i}`,
      render: (_) => formatPercent(_ === -1 ? 0 : _),
      onCell: (record) => {
        return {
          className: (record[`month_${i}`] && record[`month_${i}`] !== -1) ? record[`month_${i}`] > 0 ? cx("positive") : cx("negative") : "",
        };
      }
    });
  }

  useEffect(() => {
    getInfoManager();
  }, []);

  useEffect(() => {
    listShopDepartment.length > 0 && getNetto()
  }, [listShopDepartment]);

  return (
    <div className={cx("page-netto")}>
      <div className={cx("title")}>
        <p>{t("growth")}</p>
      </div>
      <Space direction="vertical">
        {
          listShopDepartment.length > 0 && (
            listShopDepartment.map((shopDepartment, index) => (
              <Card key={index} hoverable title={`${t('manager')}: ${shopDepartment.managerName}`}>
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={netto[index]}
                  bordered
                  pagination={false}
                  sticky
                  summary={(pageData) => {
                    return (
                      <Table.Summary fixed='bottom'>
                        <Table.Summary.Row>
                          <Table.Summary.Cell index={0}>
                            <strong>{pageData.length}</strong>
                          </Table.Summary.Cell>
                          {Array.from({ length: 12 }, (_, i) => (
                            <Table.Summary.Cell index={i + 1} className={cx('total')}>
                              <strong>
                                {formatPercent(pageData.reduce((acc, row) => acc + (row[`month_${i + 1}`] === -1 ? 0 : row[`month_${i + 1}`]), 0) / pageData.length)}
                              </strong>
                            </Table.Summary.Cell>
                          ))}
                        </Table.Summary.Row>
                      </Table.Summary>
                    );
                  }}
                />
              </Card>
            ))
          )
        }
      </Space>
    </div>
  );
};

export default Netto;
